<template>
  <button
    class="button"
    :class="`size-${size} type-${type}`"
    :disabled="disabled"
    :loading="loading"
    :only-icon="onlyIcon"
    :theme="theme"
    @click="onClick"
    @submit="onSubmit"
    @blur="onBlur"
    @mouseover="onHover"
  >
    <div v-if="loading && onlyIcon" class="animate-spin leading-[0px]">
      <i
        class="icon-loading"
        :class="{
          'text-[14px]': size !== 'large',
          'text-[17.5px]': size === 'large'
        }"/>
    </div>
    <slot v-else></slot>
  </button>
</template>

<script lang="ts" setup>
  const props = withDefaults(defineProps<{
    buttonType?: 'button' | 'submit',
    theme?: 'dark' | 'light'
    size?: 'small' | 'medium' | 'large',
    type?: 'primary' | 'secondary' | 'invert' | 'outline' | 'ghost' | 'danger' | 'danger-ghost' | 'text-link',
    loading?: boolean;
    disabled?: boolean;
    onlyIcon?: boolean;
  }>(), {
    buttonType: 'button',
    theme: 'light',
    size: 'medium',
    type: 'primary',
    loading: false,
    disabled: false,
    onlyIcon: false,
  });

  const emits = defineEmits<{
    (event: 'click', e: Event): void;
    (event: 'submit', e: Event): void;
    (event: 'blur', e: Event): void;
    (event: 'mouseover', e: Event): void;
  }>();

  function onClick(event: Event) {
    if (!props.disabled && !props.loading) {
      emits('click', event);
    }
  }

  function onSubmit(event: Event) {
    if (!props.disabled && !props.loading) {
      emits('submit', event);
    }
  }

  function onBlur(event: Event) {
    emits('submit', event);
  }

  function onHover(event: Event) {
    emits('mouseover', event);
  }
</script>

<style lang="scss" scoped>
  @import './style.scss';
</style>
